const initialState = {
    data:[],
    header:[],
    
  
  };
  
  const FOProfileReducers = (state = initialState, action: any) => {
    switch (action.type) {
            case 'FETCH_GET_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_HEADER_SUCCESS':
            return {... state, header:action.payload};
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default FOProfileReducers;
  
  